import React from 'react';
import Image from '3-components/Image/Image';
import Chip from '3-components/Chip/Chip';
import Author from '3-components/Author/Author';
import { ShortDateFromFullDateTime } from '3-components/Utils/DateUtils';

const ArticleCard = ({ hit }) => {
    const articleDateDisplay = ShortDateFromFullDateTime(hit.publish_date);
    const infoDisplay = hit.info.toLowerCase().endsWith('min') ? `${hit.info} read` : `${hit.info} min read`;

    return (
        <a className="article-card-link" href={hit.url}>
            <div className="article-card">
                <Image
                    imgSrc={hit.image ? hit.image : '/assets/images/ArticleCardDefault.jpg'}
                    imgAlt={hit.title}
                    aspectRatio="16/10"
                    imgCustomClass="artc-image-container"
                />
                <div className="artc-content-wrapper">
                    <div className="artc-date">
                        {articleDateDisplay}
                    </div>
                    <h4 className="artc-heading">
                        {hit.title}
                    </h4>
                    <div className="artc-chips-container">
                        <Chip
                            chipTitle={hit.category}
                        />

                        <Chip
                            chipIcon="clock"
                            chipTitle={infoDisplay}
                        />
                    </div>
                    <div className="artc-content">
                        {hit.description}
                    </div>
                    <Author
                        authorImgSrc={hit.author.image}
                        authorName={hit.author.name}
                        authorRole={hit.author.role}
                    />
                </div>
            </div>
        </a>
    );
};

export default ArticleCard;
